<template>
  <div
    :class="{
      [$style.container]: true,
      [$style.active]: isActive,
    }"
    @click="$emit('click')"
  >
    <div :class="$style.wrapper">
      <div
        v-m-r="20"
        v-d-flex
        v-justify="{ content: 'center' }"
        :class="[$style.logo]"
      >
        <base-icon
          v-color:dark-blue-2
          name="finance_wallet"
        />
      </div>

      <div :class="$style.content">
        <p
          :class="$style.title"
          v-text="wallet.hash"
        ></p>
        <p
          :class="$style.description"
          v-text="description"
        ></p>
      </div>
    </div>

    <div
      v-if="$scopedSlots.hasOwnProperty('action')"
      v-d-flex
      :class="$style.action"
    >
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectableWalletPanel',
  props: {
    wallet: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isActive() {
      return this.wallet.linkedForPayout;
    },
    description() {
      return this.isActive
        ? this.$t('wallet.select.panel.active') : this.$t('wallet.select.panel.inactive');
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +flex-direction(column)
    padding: 20px
    color: var(--color-white)
    background-color: var(--color-dark-blue-2)
    border-radius: 5px
    box-shadow: var(--box-shadow-base)

    &.active
      background: var(--color-dark-blue-4)

    &.disabled
      color: var(--color-grey-5)
      background-color: var(--color-dark-blue-2)

      .logo
        background-color: var(--color-grey-5)

      .description
        color: var(--color-red)

    &:not(.disabled):not(.active)

      &:hover
        background: var(--color-dark-blue-4)
        cursor: pointer

    +respond-to('small')
      +flex-direction(row)

  .wrapper
    display: flex
    align-items: center
    min-width: 0

  .content
    overflow: hidden

  .logo
    +size(40px)
    flex-shrink: 0
    background-color: var(--color-white)
    background-repeat: no-repeat
    background-position: center
    border-radius: 50%

  .title
    +font-type(medium, 14, 18)
    overflow-wrap: break-word
    word-wrap: break-word

  .description
    +font-type(regular, 12, 16)
    opacity: 0.5

  .action
    width: 100%
    margin: 0 auto
    padding: 10px 0 0

    +respond-to('small')
      width: 154px
      margin: 0 0 0 auto
      padding: 0 0 0 5px
      flex: none
</style>
